import { render, staticRenderFns } from "./script-console.vue?vue&type=template&id=bb0c9708&scoped=true&"
import script from "./script-console.vue?vue&type=script&lang=js&"
export * from "./script-console.vue?vue&type=script&lang=js&"
import style0 from "./script-console.vue?vue&type=style&index=0&id=bb0c9708&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0c9708",
  null
  
)

export default component.exports